export function initPerformanceObserver() {
  if (typeof window === 'undefined' || !('performance' in window)) return;
  const observer = new PerformanceObserver(list => {
    const entries = list.getEntries();
    entries.forEach(entry => {
      // Hook available for future logging/telemetry integrations
      // Intentionally no console noise in production
      void entry;
    });
  });
  try {
    observer.observe({ entryTypes: ['largest-contentful-paint', 'first-input', 'layout-shift'] });
  } catch (_) {
    // Silently ignore if unsupported
  }
}
